<script lang="tsx">
  import { Skeleton } from "primevue";

  export default {
    components: { Skeleton },
    props: {},
  };
</script>

<template>
  <div class="box">
    <div v-for="_ in [0, 1, 2, 3]">
      <Skeleton style="font-size: 2em"/>
      <ul>
        <li v-for="_ in new Array(Math.round(Math.random() * 2 + 1))">
          <Skeleton/>
        </li>
      </ul>
    </div>
    <div class="span copyright">
      <Skeleton/>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .p-skeleton {
    // override prime default of 1rem to emulate font-size
    height: 1em !important;
    margin-block: 0.5rem;
  }

  .box {
    display: flex;
    flex-wrap: wrap;
    justify-items: flex-start;
    justify-content: center;
    align-items: flex-start;

    padding: var(--spacing-block);
    row-gap: var(--spacing-block);
    column-gap: var(--spacing-inline);
    color: var(--p-surface-200);

    & > * {
      flex: 1 0 10em;
      width: max-content;
    }

    .span {
      flex-basis: 100%;
      width: min-content;
    }
  }

  .title, .copyright { text-align: center; }

  h3 {
    color: var(--p-surface-400);
  }

  a {
    color: var(--p-primary-600);
    &:not(:hover) {
      text-decoration: none;
    }
  }
</style>
